
import { Component, EventEmitter, Inject, Input, OnInit, Output, DOCUMENT } from '@angular/core';
import { ArtistProduct } from 'src/app/models/artistproduct.model';
import { SelectedGlaze } from 'src/app/Services/artist-portfolio-products/artist-portfolio-products.service';
import { ArtistProductSummary } from 'src/app/Services/artistproducts.service';
import { AuthConfig, AuthService } from 'src/app/Services/auth.service';

@Component({
    selector: 'app-artist-selected-product-dialog',
    templateUrl: './artist-selected-product-dialog.component.html',
    inputs: ['ArtistProduct', 'GalleryProduct', 'BusinessName', 'selectedGlasses', 'IsSharedByArtist', 'isArtist', "isGallery"],
    styleUrls: ['./artist-selected-product-dialog.component.css'],
    standalone: false
})
export class ArtistSelectedProductDialogComponent implements OnInit {
  @Input() public ArtistProduct!: ArtistProductSummary;
  public GalleryProduct!: ArtistProduct;
  public BusinessName!: string | undefined
  public selectedGlasses: SelectedGlaze[] = [];
  @Output() closeDialog: EventEmitter<void> = new EventEmitter<void>();
  public shareLink: string = '';
  public authConfig: AuthConfig = {};
  public isArtist: boolean = false;
  public isGallery: boolean = false;
  public IsSharedByArtist!: boolean;
  constructor(private authService: AuthService, @Inject(DOCUMENT) private document: Document) {
  }

  ngOnInit(): void {
    this.authConfig = this.authService.getAuthConfig();
    if (this.authConfig.IsArtist) {
      this.isArtist = true
      console.log("ArtistProduct", this.ArtistProduct);
      const baseUrl = this.document.location.origin;
      this.shareLink = `${baseUrl}/view-gallery-profile/${this.ArtistProduct.GalleryId}`;
    }
    if (this.authConfig.IsGallery) {
      this.isGallery = true
      console.log("GalleryProduct", this.GalleryProduct)
      const baseUrl = this.document.location.origin;
      this.shareLink = `${baseUrl}/profile/${this.GalleryProduct.ArtistId}`;
    }
    console.log("selectedGlasses", this.selectedGlasses);
    var currentUser = this.authService.getCurrentUser();
    if (!this.BusinessName) {
      this.BusinessName = currentUser?.BusinessName
    }
  }

  onClose(): void {
    this.closeDialog.emit();
  }
}
